// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-38eZl";
var _4 = "header-1RKeZ";
var _5 = "content-2fszx";
var _6 = "footer-1oQEe";
var _7 = "buttons-2Pe1O";
var _8 = "confirmButton-3EwO2";
var _9 = "cancelButton-2tMZO";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "header", _5 as "content", _6 as "footer", _7 as "buttons", _8 as "confirmButton", _9 as "cancelButton" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "header": _4, "content": _5, "footer": _6, "buttons": _7, "confirmButton": _8, "cancelButton": _9 }
